import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import {
  TableColumnKey,
  TableRow,
} from "src/views/Ledger/LedgerBalanceMonitor/types/Table";

function InfoFieldSection({ rowData }: { rowData: TableRow }) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);

  const array = [
    {
      label: t(TableColumnKey.ChainName),
      data: rowData[TableColumnKey.ChainName],
    },
    {
      label: t(TableColumnKey.Currency),
      data: rowData[TableColumnKey.Currency],
    },
    {
      label: t(TableColumnKey.ClientId),
      data: rowData[TableColumnKey.ClientId],
    },
  ];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        columnGap: "20px",
        rowGap: "28px",
      }}
    >
      {array.map((item, index) => (
        <div
          key={index}
          style={{
            display: "grid",
            gridTemplateColumns: "100px 1fr",
            gap: "8px",
            fontSize: "12px",
            alignItems: "center",
          }}
        >
          <div>{item.label}</div>
          <div>{item.data}</div>
        </div>
      ))}
    </div>
  );
}

export default InfoFieldSection;
